import http from '../../http'
export default {
  add: (params) => {
    return http.post('activityservice/wechatsign/insert', params)
  },
  update: (params) => {
    return http.post('activityservice/wechatsign/update', params)
  },
  del: (params) => {
    return http.post('activityservice/wechatsign/delete', params)
  },
  list: (params) => {
    return http.post('activityservice/wechatsign/list', params)
  },
  accountList: (params) => {
    // 获取授权公众号
    return http.post('activityservice/offaccountsetup/list', params)
  },
  signList: (params) => {
    // 获取签到历史
    return http.post('activityservice/prticipantsearch/signindata', params)
  },
  //签到页
  page: {
    add: (params) => {
      return http.post('activityservice/signindex/save', params)
    },
    update: (params) => {
      return http.post('activityservice/signindex/update', params)
    },
    get: (params) => {
      return http.get('activityservice/signindex/get', params)
    }
  },

  //签到成功页
  success: {
    add: (params) => {
      return http.post('activityservice/signsuccessconfig/save', params)
    },
    update: (params) => {
      return http.post('activityservice/signsuccessconfig/update', params)
    },
    get: (params) => {
      return http.get('activityservice/signsuccessconfig/getbysignid', params)
    }
  },

  // 大屏设置
  screen: {
    add: (params) => {
      return http.post('activityservice/screenconfig/insert', params)
    },
    update: (params) => {
      return http.post('activityservice/screenconfig/update', params)
    },
    list: (params) => {
      return http.post('activityservice/screenconfig/list', params)
    }
  }
}
